import React, { useEffect, useState } from 'react';
import './planConfigrationModal.scss';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import { capitalizeText, stopBackgroundScrolling, toUpperCaseWrapper } from '../../../common/utils/app.utils';
import { IP_KEYS, DEFAULT_IP_DETAIL, IP_SPEC_NAME, PRODUCT_TYPE } from '../../../common/constants/app.constants';
import IpDetails from '../ip-attributes/ip-attributes';
import ServicesDropdown from './servicesDropdown/servicesDropdown';
import { AVAILABLE_BANDWIDTH, MODULE_ID, serviceHardwareOptions, serviceOptions } from '../../../home/common/constants/constants';
import {
  faOnDedicatedPlanConfigurationModalLoad,
  faOnDedicatedKamPlanConfigurationModalLoad,
  faOnDedicatedPlanConfigurationModalSubmit,
  faOnDedicatedKamPlanConfigurationModalSubmit
} from '../../../dedicated/services/analytics.service';
import HardwareList from './hardware-list';
import { getOptions, isRFMedia } from 'dedicated/components/choose-plan/plan.service';

import { getFromSessionStorage, setInSessionStorage } from '../../../common/utils/app.utils';

import { MEDIA_TYPES } from './plan.service';
import { prepareOptionsForBandwidth } from './formControl';

function Drawer(props) {
  let {
    selectedHardwareType,
    setHardwareType,
    setSelectedRouter,
    plansArray,
    setRouterSpecsMake,
    setRouterSpecsModel,
    setPlanSlider,
    productName,
    checkLeadSatus,
    setIpAttributeType,
    ipAttributeType,
    updateDiConnectionData,
    commercialAttribute,
    planSpecs,
    planConfigrationOpen,
    setPlanConfigrationOpen,
    serviceOptions,
    onServiceChange,
    servicetype,
    paramsValue,
    showOnlyOK,
    showRouterSpecs = false,
    primaryMediaOptions = [],
    selectedPrimaryMedia = {},
    setSelectedPrimaryMedia = () => {},
    feasibilityData = {},
    selectedPlan
  } = props;

  const isSiteManualFeasible = feasibilityData && feasibilityData.feasibilityStatus === 'MANUAL_INTERVENTION_REQUIRED';
  const isSitePendingThirdParty = feasibilityData && feasibilityData.feasibilityStatus === 'PENDING_FOR_THIRD_PARTY';

  const [selectedAttributes, setSelectedAttributesData] = useState({});
  const [selectedIpDetails, setSelectedIpDetails] = useState([]);
  const [showManageServices, setShowManageServices] = useState(false);
  let [selectedserviceOption, setselectedserviceOption] = useState({});
  const [cpe, setCPE] = useState({ value: '', options: [] });
  const [cpeSpecification, setCPE_Specifications] = useState({ value: '', options: [] });
  const [primaryMedia, setPrimaryMedia] = useState(selectedPrimaryMedia);

  const [portBandwidth, setPortBandwidth] = useState({ options: [], value: {} });

  const clickServiceChange = (value) => {
    setselectedserviceOption(value);
  };

  const initalizeIpWithExisting = (lineItemsSpecs, lineItemIndex) => {
    let selectedIp = {};
    selectedIp[IP_KEYS.IP_SUBNET] = {};
    lineItemsSpecs &&
      lineItemsSpecs.map((spec) => {
        let name = spec.name;
        let value = spec.value;
        if (IP_SPEC_NAME.ipVersion === name && value) {
          selectedIp[IP_KEYS.IP_VERSION] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.routingProtocol === name && value) {
          selectedIp[IP_KEYS.ROUTING_PROTOCOL] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.ipType === name && value) {
          selectedIp[IP_KEYS.IP_TYPE] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.lanIPSubnet === name && value) {
          selectedIp[IP_KEYS.IP_SUBNET][IP_KEYS.LAN_IP_SUBNET] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.wanIPSubnet === name && value) {
          selectedIp[IP_KEYS.IP_SUBNET][IP_KEYS.WAN_IP_SUBNET] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.lanIPV6Subnet === name && value) {
          selectedIp[IP_KEYS.IP_SUBNET][IP_KEYS.LAN_IP_V6_SUBNET] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.wanIPV6Subnet === name && value) {
          selectedIp[IP_KEYS.IP_SUBNET][IP_KEYS.WAN_IP_V6_SUBNET] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.wanIPV6Subnet === name && value) {
          selectedIp[IP_KEYS.IP_SUBNET][IP_KEYS.WAN_IP_V6_SUBNET] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.noOfLAN === name && value) {
          selectedIp[IP_KEYS.NO_OF_LAN] = { displayName: value, key: value };
        } else if (IP_SPEC_NAME.noOfWAN === name && value) {
          selectedIp[IP_KEYS.NO_OF_WAN] = { displayName: value, key: value };
        }
      });

    if (!selectedIpDetails[lineItemIndex]) {
      selectedIpDetails[lineItemIndex] = [];
    }
    selectedIpDetails[lineItemIndex] = selectedIp;
    setSubNetDetails(selectedIp, commercialAttribute, 0, lineItemIndex, true);
  };
  const checkIpAatributeType = (defaultSelectedIp) => {
    let checkStatus = false;
    let defaultSelectedIps = defaultSelectedIp && defaultSelectedIp.length && defaultSelectedIp[0];
    let ipVersion = defaultSelectedIps && defaultSelectedIps[IP_KEYS.IP_VERSION] && defaultSelectedIps[IP_KEYS.IP_VERSION].key;
    let selectedIpsubnet = defaultSelectedIps && defaultSelectedIps[IP_KEYS.IP_SUBNET];
    let ipType = defaultSelectedIps && defaultSelectedIps[IP_KEYS.IP_TYPE] && defaultSelectedIps[IP_KEYS.IP_TYPE].key;
    let defaultIpSubnet =
      commercialAttribute &&
      commercialAttribute[IP_KEYS.IP_SUBNET] &&
      commercialAttribute[IP_KEYS.IP_SUBNET][ipVersion] &&
      commercialAttribute[IP_KEYS.IP_SUBNET][ipVersion][ipType];
    if (
      selectedIpsubnet &&
      selectedIpsubnet.lanIPSubnet &&
      defaultIpSubnet &&
      defaultIpSubnet.lanIPSubnet &&
      selectedIpsubnet.lanIPSubnet.key &&
      parseInt(selectedIpsubnet.lanIPSubnet.key) < defaultIpSubnet.lanIPSubnet.defaultValue
    ) {
      checkStatus = true;
    }
    if (
      selectedIpsubnet &&
      selectedIpsubnet.lanIPV6Subnet &&
      defaultIpSubnet &&
      defaultIpSubnet.lanIPV6Subnet &&
      selectedIpsubnet.lanIPV6Subnet.key &&
      parseInt(selectedIpsubnet.lanIPV6Subnet.key) < defaultIpSubnet.lanIPV6Subnet.defaultValue
    ) {
      checkStatus = true;
    }
    if (
      selectedIpsubnet &&
      selectedIpsubnet.wanIPSubnet &&
      defaultIpSubnet &&
      defaultIpSubnet.wanIPSubnet &&
      selectedIpsubnet.wanIPSubnet.key &&
      parseInt(selectedIpsubnet.wanIPSubnet.key) < defaultIpSubnet.wanIPSubnet.defaultValue
    ) {
      checkStatus = true;
    }
    if (
      selectedIpsubnet &&
      selectedIpsubnet.wanIPV6Subnet &&
      defaultIpSubnet &&
      defaultIpSubnet.wanIPV6Subnet &&
      selectedIpsubnet.wanIPV6Subnet.key &&
      parseInt(selectedIpsubnet.wanIPV6Subnet.key) < defaultIpSubnet.wanIPV6Subnet.defaultValue
    ) {
      checkStatus = true;
    }
    return checkStatus;
  };
  const setDefaultAttributeValue = (apiIpDetails) => {
    let defaultSelectedIp = Object.assign({}, DEFAULT_IP_DETAIL);
    defaultSelectedIp[IP_KEYS.IP_VERSION] = apiIpDetails &&
      apiIpDetails.configAttributesMap &&
      apiIpDetails.configAttributesMap[IP_KEYS.IP_VERSION] &&
      apiIpDetails.configAttributesMap[IP_KEYS.IP_VERSION].defaultValue && {
        displayName: apiIpDetails.configAttributesMap[IP_KEYS.IP_VERSION].defaultValue,
        key: apiIpDetails.configAttributesMap[IP_KEYS.IP_VERSION].defaultValue
      };
    defaultSelectedIp[IP_KEYS.ROUTING_PROTOCOL] = apiIpDetails &&
      apiIpDetails.configAttributesMap &&
      apiIpDetails.configAttributesMap[IP_KEYS.ROUTING_PROTOCOL] &&
      apiIpDetails.configAttributesMap[IP_KEYS.ROUTING_PROTOCOL].defaultValue && {
        displayName: apiIpDetails.configAttributesMap[IP_KEYS.ROUTING_PROTOCOL].defaultValue,
        key: apiIpDetails.configAttributesMap[IP_KEYS.ROUTING_PROTOCOL].defaultValue
      };
    defaultSelectedIp[IP_KEYS.IP_TYPE] = apiIpDetails &&
      apiIpDetails[IP_KEYS.IP_TYPE] &&
      apiIpDetails[IP_KEYS.IP_TYPE].length && { displayName: apiIpDetails[IP_KEYS.IP_TYPE][0], key: apiIpDetails[IP_KEYS.IP_TYPE][0] };
    defaultSelectedIp[IP_KEYS.NO_OF_LAN] = apiIpDetails &&
      apiIpDetails.noOfLAN &&
      apiIpDetails.noOfLAN.defaultValue && { displayName: apiIpDetails.noOfLAN.defaultValue, key: apiIpDetails.noOfLAN.defaultValue };
    defaultSelectedIp[IP_KEYS.NO_OF_WAN] = apiIpDetails &&
      apiIpDetails.noOfWAN &&
      apiIpDetails.noOfWAN.defaultValue && { displayName: apiIpDetails.noOfWAN.defaultValue, key: apiIpDetails.noOfWAN.defaultValue };
    setSelectedAttributesData(defaultSelectedIp);
    setSubNetDetails(defaultSelectedIp, apiIpDetails, 0, 0, true);
  };
  const setSubNetDetails = (selectedIp, apiIpDetails, index, lineItemIndex, updateSpecs) => {
    let ipSubnets =
      apiIpDetails &&
      apiIpDetails.ipSubnet &&
      selectedIp[IP_KEYS.IP_VERSION] &&
      apiIpDetails.ipSubnet[selectedIp[IP_KEYS.IP_VERSION].key] &&
      apiIpDetails.ipSubnet[selectedIp[IP_KEYS.IP_VERSION].key][selectedIp[IP_KEYS.IP_TYPE].key];
    selectedIp[IP_KEYS.IP_SUBNET] = selectedIp && selectedIp[IP_KEYS.IP_SUBNET] && Object.keys(selectedIp[IP_KEYS.IP_SUBNET]).length > 0 ? selectedIp[IP_KEYS.IP_SUBNET] : {};
    let selectedSubNet = '';
    let setSubnetData = {};
    ipSubnets &&
      Object.keys(ipSubnets).length &&
      Object.entries(ipSubnets).map((subnet) => {
        selectedSubNet =
          selectedIp &&
          selectedIp[IP_KEYS.IP_SUBNET] &&
          selectedIp[IP_KEYS.IP_SUBNET][subnet[0]] &&
          selectedIp[IP_KEYS.IP_SUBNET][subnet[0]].key &&
          selectedIp[IP_KEYS.IP_SUBNET][subnet[0]].key.toString();
        setSubnetData[subnet[0]] = { displayName: '/' + (selectedSubNet ? selectedSubNet : subnet[1].defaultValue), key: selectedSubNet ? selectedSubNet : subnet[1].defaultValue };
      });
    selectedIp[IP_KEYS.IP_SUBNET] = setSubnetData;
    if (!selectedIpDetails[lineItemIndex]) {
      selectedIpDetails[lineItemIndex] = [];
    }
    selectedIpDetails[lineItemIndex] = selectedIp;
    setSelectedIpDetails(selectedIpDetails);
    setIpAttributeType(checkIpAatributeType(selectedIpDetails));
    if (updateSpecs && productName !== PRODUCT_TYPE.VPN) {
      const portAndAccessBW = { portBandwidth: { ...portBandwidth?.value }, accessBandwidth: { value: selectedPlan?.speed, key: selectedPlan?.speed } };

      updateDiConnectionData([{ ...selectedIpDetails[0], ...portAndAccessBW }]);
    }
  };

  useEffect(() => {
    const bandwidths = getFromSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH);
    const { values, defaultValue } = prepareOptionsForBandwidth(bandwidths, selectedPlan?.speed);
    const options = getOptions(values, { formKey: 'portBandwidth', commercial: false });
    const value = options.filter((option) => option.key === defaultValue)[0];

    setPortBandwidth({ options, value });
    const portAndAccessBW = { portBandwidth: { ...value }, accessBandwidth: { value: selectedPlan?.speed, key: selectedPlan?.speed } };
    updateDiConnectionData([{ ...selectedIpDetails[0], ...portAndAccessBW }]);
  }, [selectedPlan?.speed]);

  useEffect(() => {
    setselectedserviceOption(servicetype === 'MANAGED' ? serviceOptions[0] : servicetype === 'UNMANAGED' ? serviceOptions[1] : serviceOptions[2]);
    stopBackgroundScrolling(planConfigrationOpen);
    if (planConfigrationOpen) {
      setPrimaryMedia(selectedPrimaryMedia);
      trackAnalytics(faOnDedicatedKamPlanConfigurationModalLoad, faOnDedicatedPlanConfigurationModalLoad);
    }
    if (planSpecs && planSpecs.length) {
      initalizeIpWithExisting(planSpecs, 0);
    } else if (commercialAttribute && commercialAttribute.configAttributesMap) {
      setDefaultAttributeValue(commercialAttribute);
      const cpeOptions = getOptions(commercialAttribute.cpe, {}, capitalizeText);
      setCPE(() => {
        return { value: cpeOptions[0], options: cpeOptions };
      });
    }
  }, [planConfigrationOpen]);

  // useEffect(() => {
  //   const cpeSpecificationOptions = getOptions(commercialAttribute && commercialAttribute?.cpeSpecification[cpe?.value?.key], {}, toUpperCaseWrapper);
  //   setCPE_Specifications({ value: cpeSpecificationOptions?.[0], options: cpeSpecificationOptions });
  // }, [cpe]);

  const updateSelectedIpDetails = (selectedIpDetail) => {
    setSelectedIpDetails(selectedIpDetail);
    setIpAttributeType(checkIpAatributeType(selectedIpDetail));
  };
  const closeDrawer = () => {
    setPlanConfigrationOpen(false);
    stopBackgroundScrolling(false);
  };
  const saveAttributeData = () => {
    setSelectedPrimaryMedia(primaryMedia);
    onServiceChange(selectedserviceOption);
    setPlanConfigrationOpen(false);
    if (selectedHardwareType && selectedHardwareType.value === 'NON_STANDARD') {
      setRouterSpecsModel(cpeSpecification);
      setRouterSpecsMake(cpe);
      let selectedRouterObj = {};
      plansArray &&
        plansArray.length > 0 &&
        plansArray.map((planData, index) => {
          let routeSpecsObj = cpeSpecification && Object.keys(cpeSpecification).length > 0 && cpeSpecification[cpe[0]][0];
          let routeSpecs = [];
          routeSpecsObj.make = cpe && cpe.length > 0 && cpe[0];
          routeSpecs.push(routeSpecsObj);
          selectedRouterObj[planData.id] = routeSpecs[0];
          setSelectedRouter({ ...selectedRouterObj });
        });
    } else {
      //setPlanSlider()
    }
    stopBackgroundScrolling(false);
    const portAndAccessBW = { portBandwidth: { ...portBandwidth?.value }, accessBandwidth: { value: selectedPlan?.speed, key: selectedPlan?.speed } };

    updateDiConnectionData([{ ...selectedIpDetails[0], ...portAndAccessBW }]);
    trackAnalytics(faOnDedicatedKamPlanConfigurationModalSubmit, faOnDedicatedPlanConfigurationModalSubmit);
  };
  const trackAnalytics = (kamEvent, customerEvent) => {
    if (paramsValue && paramsValue.user == 'KAM') {
      kamEvent && kamEvent();
    } else {
      customerEvent && customerEvent();
    }
  };

  const onCpeChange = (value) => {
    setCPE({ ...cpe, value });
  };

  const onCPE_SpecificationChnage = (value) => {
    setCPE_Specifications({ ...cpeSpecification, value });
  };

  const handleMediaTypeChange = (item) => {
    setPrimaryMedia(item);
  };

  const onPortBandWidthChange = (value) => {
    setPortBandwidth((prevData) => ({ ...prevData, value }));
  };

  return (
    <React.Fragment>
      {planConfigrationOpen && (
        <div className={`drawer_container ${planConfigrationOpen ? 'active' : ''}`}>
          <div className="drawer">
            <div className="drawer_header">
              <div className="container">
                <div className="drawer_head">
                  <div className="title_info">
                    <h4 className="title_heading">Plan Configuration</h4>
                  </div>
                  <span className="close_icon" onClick={() => closeDrawer()}></span>
                </div>
              </div>
            </div>
            <div className="drawer_body">
              <div className="scroll_content">
                <div className="container">
                  <div className="config_info">
                    <div className="info_title">
                      <span className="material-icons-outlined">settings</span>
                      <h5>
                        {' '}
                        {ipAttributeType && !checkLeadSatus()
                          ? 'You have customised your plan. Do you want standard configuration instead? '
                          : 'All the plans have a default configuration with managed services and standard IP attributes. You may customise the plans by changing the values below. '}{' '}
                        {ipAttributeType && !checkLeadSatus() && (
                          <span className="color-red" onClick={() => setDefaultAttributeValue(commercialAttribute)}>
                            Reset To Standard configuration
                          </span>
                        )}{' '}
                      </h5>
                    </div>
                    <p>Additional charges may apply in case of Non-Standard IP attributes.</p>
                  </div>
                  <div className="config_form">
                    <div className="select_info">
                      <div className="text">Media Type </div>
                    </div>

                    <div className="row">
                      <div className="flg-lg-6 flg-md-6 flg-sm-12">
                        <Select
                          label="Media Type"
                          value={primaryMedia}
                          onChange={handleMediaTypeChange}
                          options={primaryMediaOptions}
                          placeholder="Media Type"
                          required
                          disabled={isSiteManualFeasible || isSitePendingThirdParty}
                        />
                        {primaryMedia && primaryMedia.key === MEDIA_TYPES.OFFNET && (
                          <div className="text" style={{ position: 'relative', top: '-15px' }}>
                            <span className="material-icons-outlined">info</span>
                            Additional CAPEX charges may apply
                          </div>
                        )}
                        {primaryMedia && primaryMedia.key === MEDIA_TYPES.THIRD_PARTY && (
                          <div className="text" style={{ position: 'relative', top: '-15px' }}>
                            <span className="material-icons-outlined">info</span>
                            Additional Third Party charges may apply
                          </div>
                        )}
                        {isRFMedia(primaryMedia?.key) && (
                          <div className="text" style={{ position: 'relative', top: '-15px' }}>
                            Pole/Tower Height - {`${primaryMedia?.towerHeight} (Probability - 80%)` || '-'}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="select_info">
                      <div className="text">Bandwidth </div>
                      <div className="tooltip_wrap">
                        <span className="material-icons-outlined">info</span>
                        <div className="tooltip">
                          <div className="tooltip_content">
                            <p>Please note that Port Bandwidth will always be less than or equal to Access Bandwidth.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Select
                          label="Port Bandwidth"
                          value={portBandwidth.value}
                          onChange={onPortBandWidthChange}
                          options={portBandwidth.options}
                          placeholder="Port Bandwidth"
                          required
                        />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Access Bandwidth" value={selectedPlan?.speed} disabled={true} required />
                      </div>
                    </div>

                    <div className="select_info">
                      <div className="text">Service Type </div>
                      {selectedserviceOption && selectedserviceOption.value === 'MANAGED' && (
                        <div className="tooltip_wrap">
                          <span className="material-icons-outlined" onClick={() => setShowManageServices(!showManageServices)}>
                            info
                          </span>
                          {showManageServices && <ServicesDropdown setShowManageServices={setShowManageServices} />}
                        </div>
                      )}
                    </div>
                    <div className="radio_box">
                      <RadioGroup options={serviceOptions} value={selectedserviceOption} onChange={checkLeadSatus() ? '' : clickServiceChange} />
                    </div>

                    {showRouterSpecs && selectedserviceOption && selectedserviceOption.value === 'MANAGED' && (
                      <div className="row">
                        <div className="flg-lg-6 flg-md-6 flg-sm-12">
                          <Select label="Common Platform Enumeration (CPE)" value={cpe.value} onChange={onCpeChange} options={cpe.options} placeholder="CPE" required />
                        </div>
                        <div className="flg-lg-6 flg-md-6 flg-sm-12">
                          <Select
                            label="CPE Specification"
                            value={cpeSpecification.value}
                            onChange={onCPE_SpecificationChnage}
                            options={cpeSpecification.options}
                            placeholder="CPE Specification"
                            required
                          />
                        </div>
                      </div>
                    )}

                    {/* {
                                            selectedserviceOption && selectedserviceOption.value === 'MANAGED' &&
                                            <HardwareList setHardwareType={setHardwareType} selectedHardwareType={selectedHardwareType} commercialAttribute={commercialAttribute} setCpe={setCpe} setCpeSpecification={setCpeSpecification}/>
                                        } */}
                    <div className="select_info">
                      <div className="text">Internet Protocol (IP) Attributes </div>
                      <div className="tooltip_wrap">
                        <span className="material-icons-outlined">info</span>
                        <div className="tooltip">
                          <div className="tooltip_content">
                            {/* <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                                                        <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p> */}
                            <p>
                              Choose “<strong>No</strong>” for only single link and “<strong>Yes</strong>” for multiple links (Primary and Secondary links).{' '}
                            </p>
                            <ul className="tooltip_list">
                              <li>
                                You may choose <strong>Dual Last Mile</strong> for both Primary and Secondary links in order to maintain high uptime SLA.
                              </li>
                              <li>
                                Choose <strong>Dual POP</strong> for connectivity at your location for 2 different Point of Presence(POP).
                              </li>
                              <li>
                                Choose <strong>Dual Cloud</strong> for using both Airtel Cloud and Third Party Cloud,
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <IpDetails
                        selectedIpDetails={selectedIpDetails && selectedIpDetails.length > 0 && selectedIpDetails}
                        apiIpDetails={commercialAttribute}
                        lineItemIndex={0}
                        setSubNetDetails={setSubNetDetails}
                        updateSelectedIpDetails={updateSelectedIpDetails}
                        primaryMedia={primaryMedia}
                        selectedserviceOption={selectedserviceOption}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="drawer_footer">
              <div className="container">
                <div className="button_group">
                  {!showOnlyOK && (
                    <React.Fragment>
                      <Button variant="outlinebtn" onClick={() => closeDrawer()}>
                        Cancel
                      </Button>

                      {checkLeadSatus() ? (
                        <Button variant="outlinebtn" disabled>
                          Save
                        </Button>
                      ) : (
                        <Button onClick={saveAttributeData}>Save</Button>
                      )}
                    </React.Fragment>
                  )}

                  {/* {
                                        showOnlyOK &&    <Button variant="outlinebtn" onClick={() => closeDrawer()}>Close</Button>
                                    } */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default Drawer;
